import { maskedEmail } from './maskedEmail';

interface Contact {
    displayName: string;
    contactId: string;
    contactType: 'email' | 'phone';
}

export const emailContact: Contact = { displayName: maskedEmail, contactId: 'rnisuvoidwo', contactType: 'email' };

export const phoneContact: Contact = { displayName: '1 925******1', contactId: 'giw90fwrgwr', contactType: 'phone' };

export const contacts = [emailContact, phoneContact];
